import React from "react";
import { Tabs, PageHeader } from "antd";
import { Requirement } from "./requirement";
import { RequirementType } from "./requirementType";
const { TabPane } = Tabs;

export function RequirementPage() {
    return (
        <>
            <PageHeader title="Lista Requisitos" />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Tipos de requisitos" key="1">
                    <RequirementType />
                </TabPane>
                <TabPane tab="Requisitos" key="2">
                    <Requirement />
                </TabPane>
            </Tabs>
        </>
    );
}
